/* unplugin-vue-components disabled */import { render } from "./KilaKilaSideBar.vue?vue&type=template&id=662d28f8&scoped=true"
import script from "./KilaKilaSideBar.vue?vue&type=script&lang=js"
export * from "./KilaKilaSideBar.vue?vue&type=script&lang=js"

import "./KilaKilaSideBar.vue?vue&type=style&index=0&id=662d28f8&lang=less&scoped=true"

import exportComponent from "E:\\Jweb\\结课作业\\KilaKila-Blog\\kilakila-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-662d28f8"]])

export default __exports__